import Vue from 'vue'
import Router from 'vue-router'
import Layout from './views/Layout.vue'
import Login from './views/Login.vue'
import Start from './views/Start.vue'
import Home from './components/Home.vue'
import Edit from './components/Edit.vue'
import History from './components/History.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/start',
      name: 'start',
      component: Start,
    },
    { path: '/', component: Layout,
      children: [
        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: '',
          component: Home,
          meta: { requiresAuth: true },
        },
        {
          // UserPosts will be rendered inside User's <router-view>
          // when /user/:id/posts is matched
          path: 'history',
          component: History,
          meta: { requiresAuth: true },
        },
        {
          // UserPosts will be rendered inside User's <router-view>
          // when /user/:id/posts is matched
          path: 'edit/:queueId',
          component: Edit,
          meta: { requiresAuth: true },
        }
      ]
    }
    /*
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: { requiresAuth: true },
    },
    {
      path: '/list',
      name: 'list',
      component: Home,
      meta: { requiresAuth: true },
    },
    */
  ]
})
